import { useEffect, useState } from "react";
import { useT, LangSelect } from "../../lib/i18n";
import { applyBranding } from "../../lib/helpers";
import { useParams } from "react-router-dom";
import { AppMark, LightLogo } from "../../components/AppLogo";
import { ChatBubble } from "./ChatWidget";
import { WhatsAppFloat } from "../../components/ContactButtons";

export function usePublicBranding(data) {
  const { setLang } = useT();
  useEffect(() => {
    if (!data) return;
    applyBranding(data.branding);
    if (!localStorage.getItem("mcm_lang") && data.default_language) setLang(data.default_language);
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps
}

export default function PublicFrame({ branding: b, children, embed }) {
  const branding = b || {};
  const { slug } = useParams();
  const [ready, setReady] = useState(false);
  useEffect(() => { setReady(true); }, []);
  return (
    <div className={`min-h-screen bg-background ${embed ? "" : "grain"}`}>
      {!embed && <header className="sidebar">
        <div className="max-w-3xl mx-auto flex items-center justify-between px-4 sm:px-8 py-4">
          <div className="flex items-center gap-3" data-testid="public-brand">
            {!branding.logo ? <AppMark className="h-10" />
              : (branding.sidebar_style || "dark") !== "light" ? <LightLogo src={branding.logo} testId="public-brand-logo" className="h-10 max-w-[160px]" />
                : <img src={branding.logo} alt="logo" data-testid="public-brand-logo" className="h-10 w-auto max-w-[160px] object-contain" />}
          </div>
          <LangSelect testId="public-lang-toggle" />
        </div>
      </header>}
      <main className={`relative z-10 max-w-3xl mx-auto p-4 sm:p-8 ${ready ? "fade-up" : ""}`}>{children}</main>
      {!embed && slug && <ChatBubble slug={slug} />}
      {!embed && <WhatsAppFloat contact={branding.contact} />}
    </div>
  );
}
